/*
 * 1DS JS SDK Properties plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* Device.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
var Device = /** @class */function () {
  function Device() {}
  return Device;
}();
export { Device };